import { useEffect } from "react";
import TeamOverview from "../components/overview/TeamOverview";
import { useTheme } from '../../../shared/common/ThemeContext';
import { prefetchPlayerDetailsPage } from "../../../shared/players/playerDetailsCache";

const OverviewPage = ({ clubId }) => {
	const { isDarkMode } = useTheme();

  useEffect(() => {
    const start = window.requestIdleCallback
      ? (cb) => window.requestIdleCallback(cb, { timeout: 1500 })
      : (cb) => window.setTimeout(cb, 400);
    const cancel = window.cancelIdleCallback || window.clearTimeout;
    const handle = start(() => {
      prefetchPlayerDetailsPage(() => import("./PlayerDetailsPage"));
    });
    return () => cancel(handle);
  }, []);

    return (
        <div className={`flex-1 relative z-10 ${isDarkMode ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-800"}`}>
            <TeamOverview clubId={clubId} />
        </div>
    );
};

export default OverviewPage;

